import $ from 'jquery';
import Immutable from 'immutable';
import constants from 'Constants.js'
import util      from 'util/Util.js';
import objectUtil      from 'util/ObjectUtil.js';
import sequenceService  from 'SequenceService.js';
import listService  from 'ListService.js';
import template from 'behaviors/properties/main/notify/edit-notification-modal.ejs';
import editGeneralView from 'behaviors/properties/main/notify/EditNotificationGeneralView.js';
import editPersonView from 'behaviors/properties/main/notify/EditNotificationPersonView.js';
import editTimeView from 'behaviors/properties/main/notify/EditNotificationTimeView.js';
import editMessageView from 'behaviors/properties/main/notify/EditNotificationMessageView.js';
import editCancellationView from 'behaviors/properties/main/notify/EditNotificationCancellationView.js';
import editNotificationEmailView from 'behaviors/properties/main/notify/EditNotificationEmailView.js';
import BaseTableView from 'properties/BaseTableView';
import namesUtil from 'util/NamesUtil.js';

class EditNotificationModalView extends BaseTableView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl =  constants.PROP_MAIN_TABLE_NOTIFICATION_VIEW;

        // PF-4862 Was 3, causing two empty ghost rows that became part of live data
        this.defaultGridSize = 1;
        this.sanitizeHtmlMessage(opts.model.attributes.data); //PF-11543. Legacy support, sanitize the HTML that comes in the messageHtml property of each notification

        this.model.set('originalGridData',objectUtil.advancedCopy( opts.model.attributes.data? opts.model.attributes.data : []));
        this.model.set('gridData', opts.model.attributes.data ? opts.model.attributes.data : [], {silent:true});
        this.getFromBetween = {
            results:[],
            string:"",
            getFromBetween:function (sub1,sub2) {
                if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0){
                    return false;
                }
                let SP = this.string.indexOf(sub1)+sub1.length;
                let string1 = this.string.substr(0,SP);
                let string2 = this.string.substr(SP);
                let TP = string1.length + string2.indexOf(sub2);
                return this.string.substring(SP,TP);
            },
            removeFromBetween:function (sub1,sub2) {
                if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0){
                    return false;
                }
                let removal = sub1+this.getFromBetween(sub1,sub2)+sub2;
                this.string = this.string.replace(removal,"");
            },
            getAllResults:function (sub1,sub2) {
                // first check to see if we do have both substrings
                if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0){
                    return;
                }

                // find one result
                let result = this.getFromBetween(sub1,sub2);
                // push it to the results array
                this.results.push(result);
                // remove the most recently found one from the string
                this.removeFromBetween(sub1,sub2);

                // if there's more substrings
                if(this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
                    this.getAllResults(sub1,sub2);
                }
                else {
                    return;
                }
            },
            get:function (string,sub1,sub2) {
                this.results = [];
                this.string = string;
                this.getAllResults(sub1,sub2);
                return this.results;
            }
        };


        this.model.set({
            colModel: [
                { name: 'notificationId' , index: 'notificationId', hidden: true},
                { name: 'title', index: 'title',
                    width: 115, editable: false },
                { name: 'attentionLevelText', index: 'attentionLevelText',
                    width: 115, editable: false },
                { name: 'attentionLevel', index: 'attentionLevel',
                    hidden: true },
                { name: 'role', index: 'role',
                    width: 115, editable: false },
                { name: 'roleId', index: 'roleId',
                    hidden: true },
                { name: 'person', index: 'person',
                    width: 115, editable: false },
                { name: 'personType', index: 'personType',
                    hidden: true },
                { name: 'personUserName', index: 'personUserName',
                    hidden: true },
                { name: 'personUserId', index: 'personUserId',
                    hidden: true },
                { name: 'personUserGroupName', index: 'personUserGroupName',
                    hidden: true },
                { name: 'personUserGroupId', index: 'personUserGroupId',
                    hidden: true },
                { name: 'personPositionName', index: 'personPositionName   ',
                    hidden: true },
                { name: 'personPositionId', index: 'personPositionId   ',
                    hidden: true },
                { name: 'personEmailField', index: 'personEmailField',
                    hidden: true },
                { name: 'personEmailFieldId', index: 'personEmailFieldId',
                    hidden: true },
                { name: 'personEmailLiteral', index: 'personEmailLiteral',
                    hidden: true },
                { name: 'timeToDisplay', index: 'timeToDisplay',
                    width: 115, editable: false },
                { name: 'activationType', index: 'activationType',
                    hidden: true },
                {name: 'activationDate', index: 'activationDate',
                    hidden: true },
                { name: 'activationDateField', index: 'activationDateField',
                    hidden: true },
                { name: 'activationDateFieldName', index: 'activationDateFieldName',
                    hidden: true },
                {name: 'activationPeriodAmountLiteral', index: 'activationPeriodAmountLiteral',
                    hidden: true },
                { name: 'activationPeriodUnitLiteral', index: 'activationPeriodUnitLiteral',
                    hidden: true },
                {name: 'activationPeriodAmountFieldId', index: 'activationPeriodAmountFieldId',
                    hidden: true },
                { name: 'activationPeriodUnitField', index: 'activationPeriodUnitField',
                    hidden: true },
                {name: 'activationDateExpression', index: 'activationDateExpression',
                    hidden: true },
                { name: 'activationRecurisveEmailNumber', index: 'activationRecurisveEmailNumber',
                    hidden: true },
                {name: 'activationRecurisveEmailFrequency', index: 'activationRecurisveEmailFrequency',
                    hidden: true },
                { name: 'cancelAllOthers', index: 'cancelAllOthers',
                    hidden: true },
                { name: 'cancellation', index: 'cancellation',
                    width: 115, editable: false },
                { name: 'cancelType', index: 'cancelType',
                    hidden: true },
                { name: 'cancelCondition', index: 'cancelCondition',
                    hidden: true },
                { name: 'cancelScope', index: 'cancelScope',
                    hidden: true },
                { name: 'messageSendEmail', index: 'messageSendEmail',
                    hidden: true },
                { name: 'messageSubject', index: 'messageSubject',
                    hidden: true },
                { name: 'messageText', index: 'messageText',
                    hidden: true },
                { name: 'messageHtml', index: 'messageHtml',
                    hidden: true },
                { name: 'insertAttachmentSelected', index: 'insertAttachmentSelected',
                    hidden: true },
                { name: 'insertAttachment', index: 'insertAttachment',
                    hidden: true },
                { name: 'printAttachmentSelected', index: 'printAttachmentSelected',
                    hidden: true },
                { name: 'printAttachment', index: 'printAttachment',
                    hidden: true },
                { name: 'existingInstanceAttachmentSelected', index: 'existingInstanceAttachmentSelected',
                    hidden: true },
                { name: 'existingInstanceAttachment', index: 'existingInstanceAttachment',
                    hidden: true },
                { name: 'emailServerId', index: 'emailServerId',
                    hidden: true },
                { name: 'emailDisplayName', index: 'emailDisplayName',
                    hidden: true },
                { name: 'emailEmailAddress', index: 'emailEmailAddress',
                    hidden: true },
                { name: 'emailReplyToDisplayName', index: 'emailReplyToDisplayName',
                    hidden: true },
                { name: 'emailReplyToEmailAddress', index: 'emailReplyToEmailAddress',
                    hidden: true },
                { name: 'emailAuthUsername', index: 'emailAuthUsername',
                    hidden: true },
                { name: 'emailAuthPassword', index: 'emailAuthPassword',
                    hidden: true },
                { name: 'insertCheck', index: 'insertCheck',
                    hidden: true },
                { name: 'instanceCheck', index: 'instanceCheck',
                    hidden: true },
                { name: 'printCheck', index: 'printCheck',
                    hidden: true },
                { name: 'hasHtmlForm', index: 'hasHtmlForm',
                    hidden: true
                } ],
            colNames: ['Notification Id','Title', 'Attention Level', 'attentionLevel', 'Role', 'roleId',
                'Person', 'personType', 'personUserName', 'personUserId', 'personUserGroupName',
                'personUserGroupId', 'personPositionName', 'personPositionId', 'personEmailField',
                'personEmailFieldId', 'personEmailLiteral',
                'Time', 'activationType', 'activationDate', 'activationDateField','activationDateFieldName', 'activationPeriodAmountLiteral', 'activationPeriodUnitLiteral',
                'activationPeriodAmountFieldId', 'activationPeriodUnitField', 'activationDateExpression', 'activationRecurisveEmailNumber',
                'activationRecurisveEmailFrequency', 'cancelAllOthers',
                'Cancellation', 'cancelType', 'cancelCondition', 'cancelScope',
                'messageSendEmail', 'messageSubject', 'messageText', 'messageHtml', 'insertAttachmentSelected',
                'insertAttachment', 'printAttachmentSelected', 'printAttachment', 'existingInstanceAttachmentSelected',
                'existingInstanceAttachment',
                'emailServerId', 'emailDisplayName', 'emailEmailAddress', 'emailReplyToDisplayName',
                'emailReplyToEmailAddress', 'emailAuthUsername', 'emailAuthPassword', 'insertCheck', 'instanceCheck', 'printCheck',
                'hasHtmlForm']
       }, {silent:true});

        this.emptyRow = {'notificationId': '', 'title':'', 'attentionLevelText': '', 'attentionLevel': '', 'role': '', 'roleId': '',
            'person' : '', 'personType' : '', 'personUserName' : '', 'personUserId' : '', 'personUserGroupName' : '',
            'personUserGroupId' : '', 'personPositionName' : '', 'personPositionId' : '', 'personEmailField' : '',
            'personEmailFieldId' : '', 'personEmailLiteral' : '',
            'timeToDisplay' : '', 'activationType': '', 'activationDate': '', 'activationDateField': '','activationDateFieldName': '',
            'activationPeriodAmountLiteral': '', 'activationPeriodUnitLiteral': '', 'activationPeriodAmountFieldId': '', 'activationPeriodUnitField': '',
            'activationDateExpression': '', 'activationRecurisveEmailNumber': '', 'activationRecurisveEmailFrequency': '', 'cancelAllOthers': '',
            'cancellation': '', 'cancelType': '', 'cancelCondition': '', 'cancelScope': '',
            'messageSendEmail': '', 'messageSubject': '', 'messageText': '', 'messageHtml': '',
            'insertAttachmentSelected': '', 'insertAttachment': '', 'printAttachmentSelected': '', 'printAttachment': '',
            'existingInstanceAttachmentSelected': '', 'existingInstanceAttachment': '',
            'emailServerId': '', 'emailDisplayName': '', 'emailEmailAddress': '', 'emailReplyToDisplayName': '',
            'emailReplyToEmailAddress': '', 'emailAuthUsername' : '', 'emailAuthPassword': '', 'insertCheck': '', 'printCheck': '',
            'instanceCheck': '', 'hasHtmlForm': '' };

        // Update Missing Model Values When Loading From Server
        this.upgradeModel();

        return this;
    }

    sanitizeHtmlMessage(notifications){
        _.forEach(notifications, (notification) => {
            if (notification.messageHtml){
                notification.messageHtml =  util.sanitizeHTML(notification.messageHtml, true, '', true);
            }
        });         
    }

    upgradeModel() {
        let data = this.model.get('gridData');

        _.forEach(data, (n) => {
            if (n.notificationId) {
                if (!n.role) {
                    n.role = constants.ITEM_UNSPECIFIED;
                }

                if (!n.attentionLevelText) {
                    n.attentionLevelText = constants.ATTN_LEVELS[n.attentionLevel];
                }

                if (!n.title) {
                    n.title = constants.ITEM_EMPTY;
                }
                
                if (!n.person || n.person.toLowerCase().includes('undefined')  || !isNaN(n.person)) {
                    switch (n.personType) {
                        case "0":
                            n.person = 'Person currently viewing the form';
                            break;
                        case "1":
                            let role = listService.getWorkflowRole(n.roleId);
                            n.person =  role ? role.defaultPerson : constants.ITEM_UNSPECIFIED;
                            break;
                        case "2":
                            n.person = n.personUserName;
                            break;
                        case "3":
                            n.person = n.personPositionName;
                            break;
                        case "4":
                            n.person = n.personEmailLiteral;
                            break;
                        case "5":
                            const obj = listService.getObject(listService.cleanId(n.personEmailFieldId));
                            
                            if (obj) {
                                n.personEmailField = obj.model.attributes.name;
                            }
                            else{
                                n.personEmailField = listService.determineFieldName(n.personEmailFieldId);
                            }
                            n.person = 'Email taken from a field: ' + n.personEmailField;
                            break;
                        case "6":
                            n.person = n.personUserGroupName;
                            break;
                    }
                }

                if (!n.timeToDisplay) {
                    switch (n.activationType) {
                        case "0":
                            n.timeToDisplay = constants.NOTIFY_TIMES[n.activationType];
                            break;
                        case "1":
                            n.timeToDisplay = 'On ' + constants.NOTIFY_TIMES[n.activationType];
                            break;
                        case "2":
                            n.timeToDisplay = 'After ' + constants.NOTIFY_TIMES[n.activationType];
                            break;
                        case "3":
                            n.timeToDisplay = 'After a period taken from field ' + listService.determineFieldName(n.activationPeriodAmountFieldId);
                            break;
                        case "4":
                            n.timeToDisplay = 'On a date taken from field ' + listService.determineFieldName(n.activationDateField);
                            break;
                        case "5":
                        case "6":
                            n.timeToDisplay = constants.ITEM_EMPTY;
                            break;
                    }
                }


                if (!n.cancellation) {
                    n.cancellation = constants.CANCEL_TYPES[n.cancelType];
                }
            }

        })
    }

    disableNotification(e) {
        util.saveGridScrollPos(this.model,'#gbox_propModalEditTable > div.ui-jqgrid-view > div.ui-jqgrid-bdiv');
        $('#removeNotification').attr('disabled', true);
        $('#notificationTabs').addClass('disabledPanel');
        this._subviews.map( pview => {
            $(pview.id).addClass('disabledPanel');
        });
        $('button.btn-select-field').button("disable");
    }

    enableNotification(e){
        util.saveGridScrollPos(this.model,'#gbox_propModalEditTable > div.ui-jqgrid-view > div.ui-jqgrid-bdiv');
        $('#removeNotification').attr('disabled', false);
        $('#notificationTabs').removeClass('disabledPanel');
        this._subviews.map( pview => {
            $(pview.id).removeClass('disabledPanel');
        });
        $('button.btn-select-field').button("enable");
        this.model.set('newRowAdded', true, constants.MODEL_SILENT);
    }

    lastIndexOnGrid() {
        const gridData = $(this.gridEl).jqGrid('getGridParam', 'data');
        // PF-4862 Remove all behavior  notification settings rows caused exception here
        const index = gridData.length ? gridData[gridData.length-1].id : -1;
        return parseInt(index)
    }

    removeNotification(e){
        util.saveGridScrollPos(this.model,'#gbox_propModalEditTable > div.ui-jqgrid-view > div.ui-jqgrid-bdiv');
        let id = $(this.gridEl).getGridParam('selrow');
        // remove the row
        $(this.gridEl).delRowData(id);
        this.model.attributes.data.splice(id,1);
        // if necessary add blank row
        let gridData = $(this.gridEl).jqGrid('getGridParam', 'data');
        if (gridData.length < this.defaultGridSize) {
            $(this.gridEl).addRowData(this.lastIndexOnGrid()+1, this.emptyRow);
        }
        // adjust background for odd rows
        $(this.gridEl + " tr").css("background", "");
        $(this.gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
        // focus on general tab and disable buttons
        $('#edit-notification-modal a[href="#editNotificationGeneral"]').trigger('click');
        this.disableNotification(e);
        // Keep This enabled to update the removal.
        $('button.btn-select-field').button("enable");
        this.clearTabsData();
    }

    setDefaultValues() {
        let defaultData = JSON.parse(JSON.stringify(this.emptyRow));
        defaultData.activationPeriodUnitField = 'minutes';
        defaultData.activationRecurisveEmailNumber = 1;
        defaultData.cancelType = 3;
        defaultData.activationPeriodUnitLiteral ='minutes';
        defaultData.activationRecurisveEmailFrequency = 'days';
        defaultData.messageSendEmail = true;
        defaultData.insertCheck = "false";
        defaultData.instanceCheck = "false";
        defaultData.printCheck = "false";
        defaultData.hasHtmlForm = false;
        defaultData.notificationId = sequenceService.nextDomId();
        defaultData.title = constants.ITEM_EMPTY;
        defaultData.attentionLevelText = 'No attention needed';
        defaultData.attentionLevel = 0;
        defaultData.role = constants.ITEM_UNSPECIFIED;
        defaultData.roleId = 0;
        defaultData.person = constants.ITEM_EMPTY;
        defaultData.timeToDisplay = 'Now';
        defaultData.cancellation = 'The instance stage has changed';
        defaultData.cancelCondition = '';
        defaultData.cancelScope = '2';
        defaultData.personType = '1';
        defaultData.activationType = '0';
        defaultData.cancelAllOthers = 'false';

        let gridData = $(this.gridEl).jqGrid('getGridParam', 'data');
        var size = gridData.length;
        let emptyRow = this.areThereEmptyRows();

        if ( emptyRow >= 0 ){
             let data = $(this.gridEl).jqGrid('getGridParam', 'data');

            // Modify existing empty row
            if(data[emptyRow]){
               $(this.gridEl).setRowData(data[emptyRow].id, defaultData);
               this.model.attributes.data[emptyRow] = defaultData;
            }

            //data[emptyRow].id = defaultData.id;

            $(this.gridEl).setSelection(emptyRow, true);
            this.updateTabsData(emptyRow);
        } else {
            //  Add new data
            let newIndex = this.lastIndexOnGrid()+1;
            $(this.gridEl).addRowData(newIndex, defaultData);
            $(this.gridEl).setSelection(newIndex, true);
            this.model.attributes.data.push(defaultData);
            this.updateTabsData(newIndex);
        }
    }

    clearTabsData(){
        let generalTab = this._subviews.get('generalView');
        generalTab.model.set('notificationTitle', '');
        generalTab.model.set('attentionLevel', '');
        generalTab.model.set('notificationRole', '');
    }

    updateTabsData(rowIndex) {
        let data = $(this.gridEl).jqGrid('getGridParam', 'data');
        const currentData = this.model.get('gridData')[rowIndex];
        const originalData = this.model.get('originalGridData')[rowIndex];

        let rowData = $(this.gridEl).getRowData(rowIndex);

        let generalTab = this._subviews.get('generalView');
        generalTab.model.set('notificationTitle', rowData.title, {silent: true});
        generalTab.model.set('attentionLevel', rowData.attentionLevel, {silent: true});
        generalTab.model.set('notificationRolId', rowData.roleId, {silent: true});

        let personTab = this._subviews.get('personView');
        personTab.model.set('personType', rowData.personType, {silent: true});
        personTab.model.set('personUserName', rowData.personUserName, {silent: true});
        personTab.model.set('personUserId', rowData.personUserId, {silent: true});
        personTab.model.set('personUserGroupName', rowData.personUserGroupName, {silent: true});
        personTab.model.set('personUserGroupId', rowData.personUserGroupId, {silent: true});
        personTab.model.set('personPositionName', rowData.personPositionName, {silent: true});
        personTab.model.set('personPositionId', rowData.personPositionId, {silent: true});
        personTab.model.set('personEmailField', rowData.personEmailField, {silent: true});
        personTab.model.set('personEmailFieldId', rowData.personEmailFieldId, {silent: true});
        personTab.model.set('personEmailLiteral', rowData.personEmailLiteral, {silent: true});

        let timeTab = this._subviews.get('timeView');
        timeTab.model.set('activationType', rowData.activationType, {silent: true});
        timeTab.model.set('activationDate', rowData.activationDate, {silent: true});
        timeTab.model.set('activationDateField', rowData.activationDateField, {silent: true});
        if(rowData.activationType === "4" && rowData.activationDateFieldName === "" && rowData.activationDateField !== ""){
            rowData.activationDateFieldName = listService.getObjectName(listService.cleanId(rowData.activationDateField));
        }   
        timeTab.model.set('activationDateFieldName', rowData.activationDateFieldName, {silent: true});
        timeTab.model.set('activationPeriodAmountLiteral', rowData.activationPeriodAmountLiteral, {silent: true});
        timeTab.model.set('activationPeriodUnitLiteral', rowData.activationPeriodUnitLiteral.toLowerCase(), {silent: true});
        timeTab.model.set('activationPeriodAmountFieldId', rowData.activationPeriodAmountFieldId, {silent: true});
        timeTab.model.set('activationPeriodUnitField', rowData.activationPeriodUnitField.toLowerCase(), {silent: true});
        timeTab.model.set('activationDateExpression',
                            rowData.activationDateExpression? JSON.parse(rowData.activationDateExpression):
                                                              rowData.activationDateExpression, {silent: true});
        timeTab.model.set('activationRecurisveEmailNumber', rowData.activationRecurisveEmailNumber, {silent: true});
        timeTab.model.set('activationRecurisveEmailFrequency', rowData.activationRecurisveEmailFrequency.toLowerCase(), {silent: true});
        timeTab.model.set('cancelAllOthers', rowData.cancelAllOthers, {silent: true});


        //PF-6182 In the modal the html message must be displayed decoded with the html tags
        let getMessageHtml = originalData ? originalData.messageHtml : rowData.messageHtml;
        getMessageHtml = util.decodeForHTMLNotification(getMessageHtml);

        let messageText=(rowData.messageText);
        messageText=this.replaceItem(messageText);

        let messageSubject=(rowData.messageSubject);
        messageSubject=this.replaceItem(messageSubject);
        messageSubject=(messageSubject).replace(/&quot;/gi,'\n');

        let messageTab = this._subviews.get('messageView');
        messageTab.model.set('messageSendEmail', rowData.messageSendEmail, {silent: true});
        messageTab.model.set('messageText',messageText, {silent: true});
        messageTab.model.set('messageHtml', getMessageHtml, {silent: true});
        messageTab.model.set('messageSubject', messageSubject, {silent: true});
        messageTab.model.set('insertAttachmentSelected', rowData.insertAttachmentSelected, {silent: true});
        messageTab.model.set('insertAttachment', rowData.insertAttachment, {silent: true});
        messageTab.model.set('insertCheck', rowData.insertCheck, {silent: true});
        messageTab.model.set('printAttachmentSelected', rowData.printAttachmentSelected, {silent: true});
        messageTab.model.set('printAttachment', rowData.printAttachment, {silent: true});
        messageTab.model.set('printCheck', rowData.printCheck, {silent: true});
        messageTab.model.set('existingInstanceAttachmentSelected', rowData.existingInstanceAttachmentSelected, {silent: true});
        messageTab.model.set('existingInstanceAttachment', rowData.existingInstanceAttachment, {silent: true});
        messageTab.model.set('instanceCheck', rowData.instanceCheck, {silent: true});

        let cancellationTab = this._subviews.get('cancellationView');
        cancellationTab.model.set('cancellation', rowData.cancellation, {silent: true});
        cancellationTab.model.set('cancelType', rowData.cancelType, {silent: true});
        cancellationTab.model.set('cancelCondition', currentData ? currentData.cancelCondition : rowData.cancelCondition, {silent: true});
        cancellationTab.model.set('cancelScope', rowData.cancelScope, {silent: true});

        let emailTab = this._subviews.get('emailView');
        emailTab.model.set('emailServerId', rowData.emailServerId, {silent: true});
        emailTab.model.set('emailDisplayName', rowData.emailDisplayName, {silent: true});
        emailTab.model.set('emailEmailAddress', rowData.emailEmailAddress, {silent: true});
        emailTab.model.set('emailReplyToDisplayName', rowData.emailReplyToDisplayName, {silent: true});
        emailTab.model.set('emailReplyToEmailAddress', rowData.emailReplyToEmailAddress, {silent: true});
        emailTab.model.set('emailAuthUsername', rowData.emailAuthUsername, {silent: true});
        emailTab.model.set('emailAuthPassword', rowData.emailAuthPassword, {silent: true});

        this.renderTabs();
    }

    replaceItem(item){
        if (util.isEmpty(item)) {
            return item;
        }
        let messageText=(item);
        
        messageText = messageText.replace(/P>/g,'p>');
        let rows = messageText.split('</p>');

        const textEncoded = ['<p align="left" style="margin:0px;padding:0px;">', '<p align="left">', '<p align="left">', '<p align="LEFT">', //Chrome
                            '<p style="margin:0px;padding:0px;" align="left">', //Firefox
                            '<p align=\"left\" style=\"margin: 0px; padding: 0px;\">', '<p align=\"left\">', '<p align=\"LEFT\">']; //IE

        messageText= '';
        for (let i = 0; i < rows.length; i++) {
            if (!util.isEmpty(rows[i]) ) {
                _.each(textEncoded, (text) => {
                    rows[i] = rows[i].replace(text, '');
                });
                rows[i] = rows[i].replace('</p>', '');
                rows[i] = rows[i].replace('<br>', '');

                messageText += (i >0? '\n':'') + rows[i];
            }
        }

        let lstControls=this.getFromBetween.get(messageText,"{","}");
        let size=lstControls.length;
        for(let i=0;i<size;i++){
            let idControl=this.getFromBetween.get(lstControls[i],"id=\"","\"");
            if(idControl.length>0){
                idControl=idControl[0];
                idControl=namesUtil.determineFieldName(idControl);
                messageText=messageText.replace(lstControls[i], idControl);
            }
        }

        //Remove brackets in case the field was not found
        messageText = messageText.replace(/{}/g,'');

        return messageText;
    }

    areThereEmptyRows(){
        let rowIndex = -1;
        let dataGrid = $(this.gridEl).jqGrid('getGridParam', 'data');
        let index = 0;
        while (rowIndex < 0 && index < dataGrid.length && dataGrid.length <= this.defaultGridSize ) {
            let row = dataGrid[index];
            if (this.isEmpty(row)) {
                rowIndex = index;
            }
            ++index;
        }
        return rowIndex;
    }

    isEmpty(row){
        return !row.title && !row.attentionLevel && !row.role && !row.person && !row.activationType && !row.cancellation;
    }

    encodeText(text){
        if(text.trim().length===0){
            return text;
        }
        if (text.toLowerCase().includes('<p align="left" style="margin:0px;padding:0px;">') ||
            text.toLowerCase().includes('<p style="margin:0px;padding:0px;" align="left">')  ||
            text.toLowerCase().includes('<p align="left">')){
            return text;
        }

        let rows=text.replace(/<br[^>]*>/gi,'\n');
        rows= $('<div/>').html(rows).text();

        rows=rows.split('\n');
        let textEncoded='';

        // PF-4862 -- Functional - easier to read and maintain
        rows.forEach( item => {
            textEncoded +='<p align="left" style="margin:0px;padding:0px;">';
            textEncoded += (util.isEmpty(item) ? '<br>' : item);
            textEncoded +='</p>';
        });

        return textEncoded;
    }

    changeNameForId(msgText){

        let lstControls = this.getFromBetween.get(msgText, "{", "}");

        let size = lstControls.length;
        let messageText = msgText;


        const mapObj = {
            '- Value': '',
            '- Caption': '',
            '-  Current Row': '',
            '-  All Rows': ''
        };

        const re = new RegExp(Object.keys(mapObj).join("|"), "gi");

        for (let i = 0; i < size; i++) {

            let name = lstControls[i];
            let table = name.indexOf('Current Row') > -1 || name.indexOf('All Rows') >- 1;

            let newName = name.replace(re, function(matched){
                return mapObj[matched];
            });

            let idControl = '';
            let ctrlName = '';

            ctrlName = newName.trim();

            if(table){
                ctrlName = newName.split('-')[0].trim();
            }


            let ctrl = listService.getObjectByParam('name', ctrlName, true);
            if(ctrl !== null){

                if(ctrl.model.get('factoryKey')==='control_drop_down' && lstControls[i].trim().toLowerCase().indexOf('value')>-1){
                    idControl += listService.getCleanedId(ctrl.model.get('id'))+'$v';
                }else if(ctrl.model.get('factoryKey')==='control_table'){
                    
                    let tbChildren = ctrl.model.get('selectFields');                    
                    if(tbChildren && tbChildren.length){

                        const fieldName = lstControls[i].split('-');
                        const columnName = fieldName[1] ? fieldName[1].trim() : ""; 
                        const row = fieldName[2] ? fieldName[2].trim() : ""; 

                        let tableField = tbChildren.filter(field => field.text.indexOf(columnName) > -1 && field.text.indexOf(row) > -1);
                        
                        //PF-6448 If it has the caption or value text then it is a drop down column and an extra filter is required
                        if(fieldName.length > 3){
                            const type = fieldName[3] ? fieldName[3].trim() : "";
                            tableField = tableField.filter(field => field.text.indexOf(type) > -1);
                        }                       

                        if(tableField && tableField.length){
                            idControl += tableField[0].id;
                        }

                    }
                }
                else{
                    idControl+=ctrl.model.get('id');
                }

                if(idControl!==''){
                    messageText=messageText.replace('{'+lstControls[i]+'}', '{field id="'+ listService.getCleanedId(idControl) + '"}' );
                }
            }
        }
        return messageText;
    }

    getGridInfoArray(){
        const data = $(this.gridEl).jqGrid('getGridParam', 'data');
        const dataFromModel = this.model.get("data");
        let result = [];
        for (let rowIndex in data) {
            if (!this.isEmpty(data[rowIndex])) {

                let messageText = !data[rowIndex].messageText ? '' : data[rowIndex].messageText.trim();
                let messageSubject = !data[rowIndex].messageSubject ? '' : data[rowIndex].messageSubject.trim();

                messageText = this.changeNameForId(messageText);               
                messageSubject = this.changeNameForId(messageSubject);
                messageSubject = $('<div/>').html(messageSubject).text();

                data[rowIndex].messageText=this.encodeText(messageText);
                data[rowIndex].messageSubject=(messageSubject);
                
                if (data[rowIndex].activationType === '5'){
                    // Construct the ActivationDateExpression for formulas
                    let formulaString = data[rowIndex].activationDateExpression;
                    data[rowIndex].activationDateExpression = JSON.parse(data[rowIndex].activationDateExpression);
                }

                //Takes the data from the model instead of the jqGrid because it is an object
                if(data[rowIndex].cancelCondition !== ""){
                    data[rowIndex].cancelCondition = dataFromModel[rowIndex].cancelCondition;
                }

                //Since the values come from the jqgrid the html values are encoded so they should be decoded before returning the value
                data[rowIndex].messageHtml = util.decodeForHTMLNotification(data[rowIndex].messageHtml);

                result.push(data[rowIndex]);
            }
        }

        return result;
    }

    initializeGrid() {
        let gridData = this.model.get('gridData');
        let actualSize = gridData.length;
        for (let i =0; i< actualSize; ++i) {
            if (gridData[i].activationType === '5') {
                gridData[i].activationDateExpression = JSON.stringify(gridData[i].activationDateExpression);
            }

            //PF-6182 In the grid the html message must be encoded, html tags break this
            if(gridData[i].messageHtml && !util.isHtmlEncoded(gridData[i].messageHtml)){
                gridData[i].messageHtml = util.encodeForHTMLNotification(gridData[i].messageHtml);
            }
            
            $(this.gridEl).addRowData(i, gridData[i]);
        }

        if (actualSize < this.defaultGridSize) {
            for (let i =actualSize; i<this.defaultGridSize; ++i) {
                let defaultData = JSON.parse(JSON.stringify(this.emptyRow));
                gridData.push(defaultData);
                $(this.gridEl).addRowData(i, defaultData);
            }
            this.model.set('gridData', gridData);
        }
    }

    onCellSelect(rowid, iCol, cellcontent,e){
        this.model.unset('newRowAdded', constants.MODEL_SILENT);
        util.saveGridScrollPos(this.model);

        let rowData = $(this.gridEl).getRowData(rowid);
        if (this.isEmpty(rowData)) {
            $(this.gridEl).setSelection(rowid, false);
            this.disableNotification(e);
            this.clearTabsData();
        } else {
            $(this.gridEl).setSelection(rowid, true);
            this.enableNotification(e);
            this.updateTabsData(rowid);
        }
        return;
    }

    setRow(rowId,e) {
      this.model.set({
        rowid: rowId
      }, {silent: true});
      $(`#${e.currentTarget.id}`).jqGrid('setSelection', rowId);
    }

    afterEditCell(rowId, cellName, value, iRow, iCol) {
        let self=this;
        console.log("After activated","#" + iRow + "_" + cellName);
        $("#" + iRow + "_" + cellName).bind('blur', function () {
            console.log("Blur activated");
            $(self.gridEl).saveCell(iRow, iCol);
        });
  }

    closeModal() {
        $('#edit-notification-modal').remove();
    }

    createGrid() {
        let self = this;
        $(self._gridEl).jqGrid({
            datatype: "local",
            shrinkToFit: true,
            autowidth: true,
            altRows: true,
            cellEdit: true,
            height: 80,
            scrollerbar: false,
            cellsubmit : 'clientArray',
            onCellSelect: function(rowid, iCol, cellcontent,e){
                self.onCellSelect(rowid, iCol, cellcontent,e);
            },
            gridComplete: function() {
                $(self._gridEl + " tr.jqgrow:odd").css("background", "#DDDDDC");
            },
            colNames: self.model.get('colNames'),
            colModel: self.model.get('colModel'),
            beforeSelectRow: function (rowid,e) {
                self.setRow(rowid,e);
            },
            afterSaveCell: function (rowid, cellname, value) {
                self.saveCell(rowid, cellname, value);
            }
        });
        self.initializeGrid();
        self.resizeGrid();
    }

    renderTabs() {
        if (this._subviews) {
            this.delegateEvents();
            this._subviews.map( pview => {
                pview.render();
                pview.delegateEvents();
            });
            util.setGridScrollPos(this.model, '#gbox_propModalEditTable > div.ui-jqgrid-view > div.ui-jqgrid-bdiv');
        }
    }

    createTabs() {
        this._subviews = Immutable.Map()
            .set( 'generalView', new editGeneralView( { model: this.model, el: $('#editNotificationGeneral')} ))
            .set( 'personView', new editPersonView( { model: this.model, el: $('#editNotificationPerson')} ))
            .set( 'timeView', new editTimeView( { model: this.model, el: $('#editNotificationTime')} ))
            .set( 'messageView', new editMessageView( { model: this.model, el: $('#editNotificationMessage')} ))
            .set( 'cancellationView', new editCancellationView( { model: this.model, el: $('#editNotificationCancellation')} ))
            .set( 'emailView', new editNotificationEmailView( { model: this.model, el: $('#editNotificationEmail')} ))
        ;

        if (this._subviews) {
            this.delegateEvents();
            this._subviews.map( pview => {
                pview.render();
                pview.delegateEvents();
                $(pview.id).addClass('disabledPanel');
            });
        }
        $('#notificationTabs').addClass('disabledPanel')

    }

    bindEvents() {
        $('#addNotificationButton').on("click", (e)=>{
            this.enableNotification(e);
            this.setDefaultValues();
            $('#edit-notification-modal a[href="#editNotificationGeneral"]').trigger('click');
        });
        $('#removeNotification').on("click", (e)=>{
            this.removeNotification(e);
        });
    }

    unbindEvents() {
        $('#addNotificationButton').off();
        $('#removeNotification').off();
    }

    render() {
        let self = this;

        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);
            
            listService.isUndoRedoEnabled = false;

            // Show modal popup window
            this.dialog = $('#edit-notification-modal').dialog({
                autoOpen: true,
                height: 625,
                width: 675,
                modal: true,
                resizable: true,
                resize: function(event, ui) {
                    $(self._gridEl).jqGrid("setGridWidth", event.target.clientWidth - 40, true);
                },
                buttons: [
                    {
                        text: 'OK',
                        'class': 'btn-select-field',
                        'disabled': true,
                        click: () => {
                            // TODO
                            let result = this.getGridInfoArray();

                            this.dialog.dialog("close");
                            this.closeModal();
                            resolve(result);
                        }
                    },
                    {
                        text: 'Cancel',
                        'class': 'btn-addAssetCancel',
                        click: () => {
                            this.dialog.dialog("close");
                            this.closeModal();
                            // TODO
                            reject({message:constants.DIALOG_CANCELED,originalData:this.model.get('originalGridData')});
                        }
                    }
                ],
                close: () => {
                    listService.isUndoRedoEnabled = true;
                    this.dialog.dialog('destroy').remove();
                    this.unbindEvents();
                    this.closeModal();
                },
                open: () => {
                    $(self._gridEl).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
                    self.createGrid();
                    self.createTabs();
                    self.bindEvents();
                }
            });

            $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);


            var $titlebar = $( ".ui-dialog-titlebar" );

            var $button = $( "<button/>" ).text( this.text ),
                right = $titlebar.find( "[role='button']:last" )
                    .css( "right" );

            $button.button({
                icons: { primary: 'ui-icon-help' },
                text: false
            }).addClass( "ui-dialog-titlebar-close" )
                .css( {"right": ( parseInt( right ) + 22) + "px", 'marginRight': '20px'})
                .on("click", function() {
                    window.open(constants.URL_NOTIFICATIONS);
                })
                .appendTo( $titlebar );

            this.delegateEvents();
            return this;
        });

        

    }
}

export default EditNotificationModalView;
